import axios from 'axios';
import { BASE_URL } from '../helpers/constant';
import UserService from '../utils/UserService';

const client = () => {
  const token = UserService.getToken() || '';
  const client = axios.create({
    baseURL: BASE_URL,
    timeout: 60000,
    headers: {
      authorization: `Bearer ${token}`,
      Accept: 'application/json',
    },
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle connection refused errors (server not running)
      if (
        error.code === 'ERR_CONNECTION_REFUSED' ||
        error.code === 'ERR_NETWORK'
      ) {
        window.location.href = '/error';
        return Promise.reject({
          isNetworkError: true,
          message:
            'Unable to connect to the server. Please check your internet connection.',
        });
      }

      // Check if it's a timeout error (server unreachable)
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        window.location.href = '/error';
        return Promise.reject({
          isNetworkError: true,
          message: 'Request timed out. Please check your internet connection.',
        });
      }

      // For other errors, don't redirect to error page
      return Promise.reject(error);
    },
  );

  return client;
};

export default client;
